import React from 'react'

import { mapValues } from 'lodash-es'

import { MapTeamPositionProvider } from '@/components/organisms/Map/Markers/MapTeamPositionProvider.tsx'
import { useTeamsLatestLocation } from '@/model/contexts/useTeamsLatestLocation.ts'

export const AppMapTeamPositionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const teamsLatestLocation = useTeamsLatestLocation()
  const positions = React.useMemo(() => mapValues(teamsLatestLocation, 'geolocation'), [teamsLatestLocation])
  return <MapTeamPositionProvider positions={positions}>{children}</MapTeamPositionProvider>
}
